import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '16px',
      fontWeight: 600,
      marginBottom: '10px'
    },
    qtd: {
      '@media (max-width:425px)': {
        display: 'none'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
